import homeImg from '../assets/img/home.png';
import aboutImg from '../assets/img/about.png';
import ourStoryImg from '../assets/img/our-story.png';

/**
 * Demo hero slides shown on the home page when the store
 * has not added any hero items yet.
 */
export const heroItemsPlaceholder = [
    {
        id: 'placeholder-hero-1',
        status: 'active',
        imageUrl: homeImg,
        title: {
            en: 'Savor the Taste of Authentic Cuisine',
            tr: 'Otantik Mutfağın Tadını Çıkarın',
            fa: 'طعم اصیل غذا را بچشید',
            ar: 'تذوق نكهة المطبخ الأصيل',
            el: 'Γευτείτε την Αυθεντική Κουζίνα',
            ru: 'Насладитесь вкусом настоящей кухни',
        },
        description: {
            en: 'Experience the finest dining with a variety of dishes prepared to perfection. Your culinary journey starts here.',
            tr: 'Özenle hazırlanan çeşitli yemeklerle en iyi yemek deneyimini yaşayın. Mutfak yolculuğunuz burada başlıyor.',
            fa: 'با انواع غذاهای آماده‌شده با دقت، بهترین تجربه غذایی را داشته باشید. سفر آشپزی شما از اینجا آغاز می‌شود.',
            ar: 'استمتع بأرقى تجربة طعام مع أطباق متنوعة معدة بإتقان. رحلتك الطهوية تبدأ هنا.',
            el: 'Ζήστε την καλύτερη γαστρονομική εμπειρία με ποικιλία πιάτων φτιαγμένων στην εντέλεια. Το γαστρονομικό σας ταξίδι ξεκινά εδώ.',
            ru: 'Откройте для себя изысканную кухню с блюдами, приготовленными до совершенства. Ваше кулинарное путешествие начинается здесь.',
        },
    },
    {
        id: 'placeholder-hero-2',
        status: 'active',
        imageUrl: aboutImg,
        title: {
            en: 'Fresh Ingredients, Memorable Moments',
            tr: 'Taze Malzemeler, Unutulmaz Anlar',
            fa: 'مواد تازه، لحظات به‌یادماندنی',
            ar: 'مكونات طازجة ولحظات لا تُنسى',
            el: 'Φρέσκα Υλικά, Αξέχαστες Στιγμές',
            ru: 'Свежие ингредиенты, незабываемые моменты',
        },
        description: {
            en: 'From seasonal produce to carefully crafted plates, every visit is made to feel like a celebration at the table.',
            tr: 'Mevsimlik ürünlerden özenle hazırlanan tabaklara, her ziyaret sofrada bir kutlama gibi hissettirir.',
            fa: 'از محصولات فصلی تا بشقاب‌های با دقت ساخته‌شده، هر بازدید حس جشن روی میز را دارد.',
            ar: 'من المنتجات الموسمية إلى الأطباق المصنوعة بعناية، كل زيارة تشعرك بالاحتفال على المائدة.',
            el: 'Από εποχιακά προϊόντα έως προσεκτικά φτιαγμένα πιάτα, κάθε επίσκεψη μοιάζει με γιορτή στο τραπέζι.',
            ru: 'От сезонных продуктов до тщательно приготовленных блюд — каждый визит ощущается как праздник за столом.',
        },
    },
    {
        id: 'placeholder-hero-3',
        status: 'active',
        imageUrl: ourStoryImg,
        title: {
            en: 'Book a Table & Dine With Us',
            tr: 'Masa Ayırtın ve Bizimle Yemek Yiyin',
            fa: 'میز رزرو کنید و با ما غذا بخورید',
            ar: 'احجز طاولة وتناول الطعام معنا',
            el: 'Κλείστε Τραπέζι και Φάτε Μαζί Μας',
            ru: 'Забронируйте столик и поужинайте у нас',
        },
        description: {
            en: 'Reserve your spot for lunch or dinner, explore the full menu online, and enjoy hospitality that feels personal.',
            tr: 'Öğle veya akşam yemeği için yerinizi ayırtın, menüyü online keşfedin ve kişisel bir misafirperverlik yaşayın.',
            fa: 'جای خود را برای ناهار یا شام رزرو کنید، منوی کامل را آنلاین ببینید و از مهمان‌نوازی شخصی لذت ببرید.',
            ar: 'احجز مكانك للغداء أو العشاء، واستكشف القائمة كاملة عبر الإنترنت، واستمتع بضيافة شخصية.',
            el: 'Κλείστε θέση για μεσημεριανό ή δείπνο, εξερευνήστε το πλήρες μενού online και απολαύστε φιλοξενία που μοιάζει προσωπική.',
            ru: 'Забронируйте место на обед или ужин, изучите полное меню онлайн и ощутите гостеприимство, которое чувствуется лично.',
        },
    },
];
